import get from '@/ajax/collection/get';
import selectedFilter from '@/ajax/collection/selected-filter';

/**
 * @module ajaxAPI/collection
 *
 * @description
 * Ajax-обертки для работы с коллекцией
 */

const collection = {
  get,
  selectedFilter
};

export default collection;
